const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/buyer/dom/manage/order/price/detail',
        data: data
    }
    return __request(pParameter)
}
export default request